import {Button, Upload as AntUpload, UploadFile, UploadProps} from "antd";
import {ReactElement, useEffect, useState} from "react";
import * as minio from "../../utils/minio";


interface Props extends Omit<UploadProps, 'onChange'> {
    value?: Array<string | UploadFile> | string
    onChange?: (data: string | UploadFile | Array<string | UploadFile>) => void
    customRender?: boolean
}

function Upload(props: Props) {

    const {value, onChange, customRender = false, ...otherProps} = props

    const [fileList, setFileList] = useState<any>([])

    useEffect(() => {
        const newValue = (props.value instanceof Array) ? props.value : [props.value].filter(i => !!i)
        const files = newValue?.map((item: any) => {
            if (typeof (item) === 'string') {
                return {
                    url: item.startsWith('http') ? item : minio.getUrl(item),
                    name: item,
                }
            } else {
                return item
            }
        })
        setFileList(files)
    }, [props.value])

    const children = props.children;

    function handleChange(data: any) {
        if (props.maxCount === 1) {
            const file = data.fileList[0]
            onChange?.(file?.url || file)
        } else {
            onChange?.(data.fileList.map((item: any) => item.url || item))
        }
    }

    function renderItem(originNode: ReactElement, file: UploadFile, fileList: object[]) {
        if (customRender) {
            if (file.url) {
                return (
                    <a onClick={() => window.open(file.url)}>{file.name}</a>
                )
            } else {
                return originNode
            }
        } else {
            return originNode
        }
    }

    return (
        <AntUpload {...otherProps} onChange={handleChange} fileList={fileList} beforeUpload={() => false}
                   itemRender={renderItem}>
            {(!props.maxCount || props.maxCount > fileList.length) && (
                children ? children : (<Button type={'primary'} disabled={otherProps.disabled}>上传</Button>)
            )}
        </AntUpload>
    )
}

type ValidatorConfig = {
    limit?: number
    fileType?: any
}
Upload.validator = (config: ValidatorConfig) => {
    if (config.limit) {
        const limitValidate = (value?: string | UploadFile) => {
            if (typeof value == 'string' || !value) return true;
            const limit = config.limit;
            if (value?.size!! > limit!!) {
                return false;
            }
            return true;
        };
        return async function (rule: any, value: Props['value'] | UploadFile) {
            if (Array.isArray(value)) {
                const result = value.map((v, index) => ({
                    flag: limitValidate(v),
                    index,
                    name: typeof v === 'string' ? v : v.name
                }));
                const errorList = result.filter(res => res.flag);
                errorList.length && Promise.reject(errorList.map(e => `${e.name} 超出大小限制`).join(','));
                return;
            }
            const flag = limitValidate(value as string | UploadFile);
            if (!flag) {
                return Promise.reject('文件超出限制');
            }
            return Promise.resolve();
        }
    }
}

export default Upload
